import { FetchResult, gql } from 'apollo-boost';
import { IUserPlan } from '../../../models/user-plan';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const QUERY = gql`
    query {
        available_user_plans_for_user {
            uid,
            name,
            accessType: access_type,
            finalUnitIndex: final_unit_index,
            description,
        }
    }
`;

export async function getAvailablePlansForUser(): Promise<IUserPlan[]> {
    const result: FetchResult<{ available_user_plans_for_user: IUserPlan[] }> = await graphqlClient.query({
        query: QUERY,
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.available_user_plans_for_user;
}
